<div>
  
    <div [formGroup]="form">
      <div class="row">
        <div class="col-md-6 col-lg-6">
          <div class="form-group">
            <label>Param Type</label>
            <select name="" id="" formControlName="type" class="form-control">
              <option value="" disabled selected hidden>--- select type ---</option>
              <option value="{{param}}" *ngFor="let param of paramTypes">{{param}}</option>
            </select>
            <span class="err" *ngIf="form.get('type').invalid && formSubmit">param type required</span>
          </div>
        </div>
        <div class="col-md-6 col-lg-6">
          <div class="form-group">
            <label>Param Name</label>
            <input formControlName="name" type="text" class="form-control">
            <span class="err" *ngIf="form.get('name').invalid && formSubmit">param type required</span>
          </div>
        </div>

        <div class="col-md-6 col-lg-6">
          <div class="form-group">
            <label>Box Type</label>
            <select name="" id="" (change)="boxTypeChange()" formControlName="boxType" class="form-control">
              <option value="" disabled selected hidden>--- select type ---</option>
              <option value="{{type}}" *ngFor="let type of type">{{type}}</option>
            </select>
          </div>
        </div>

        <div class="col-md-6 col-lg-6">
          <div class="form-group">
            <label>Required</label>
            <select name="" id="" formControlName="isMandatory" class="form-control">
              <option value="" disabled selected hidden>--- select required ---</option>
              <option value="true">No</option>
              <option value="false">Yes</option>
            </select>
          </div>
        </div>
      </div>


      <div formArrayName="possibleValue" *ngIf="form.get('boxType').value == 'Dropdown'">
        <div *ngFor="let object of form.controls.possibleValue['controls'];let i = index;let last = last" [formGroupName]="i">
            <div class="row">
                <div class="col-md-10 col-lg-10">
                    <div class="form-group">
                      <input formControlName="key" placeholder="enter possiblevalue" type="text" class="form-control">
                    </div>
                    <span class="err" *ngIf="paramArr.controls[i].get('key')?.invalid && formSubmit">key required</span>

                </div>
                <div class="col-md-2 col-lg-2 paramBtn" *ngIf="last">
                    <svg xmlns="http://www.w3.org/2000/svg" (click)="addpossibleValue()" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removepossibleValue(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                    </svg>
                </div>
                <div class="col-md-2 col-lg-2 paramBtn1" *ngIf="!last">
                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removepossibleValue(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                    </svg>
                </div>
            </div>
        </div>
      </div>


  </div>


<div class="modal-footer">
  <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
  <button type="button" (click)="addParam()" class="btn btn-primary">Add Param</button>
</div>
</div>